module.exports = __webpack_public_path__ + "img/videobgc5.93cf3e08.png";